/**
 * Portal ICAVI - Serviço de domínio: Portaria - Fechamento de Almoços
 * Extraído de apiService.ts para reduzir o tamanho do módulo monolítico (RF-07).
 */
import axios from 'axios';
import { api } from '../apiClient';
export const portariaServiceMethods = {
    async listarAlmocosPortaria() {
        try {
            const response = await api.get('/api/portaria/almocos');
            return response.data;
        }
        catch (error) {
            console.error('Erro ao listar almoços da portaria:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async listarValoresDiferenciadosAlmocoPortaria(params) {
        try {
            const queryParams = new URLSearchParams();
            queryParams.append('mes_referencia', params.mes_referencia);
            if (params.almoco_id)
                queryParams.append('almoco_id', String(params.almoco_id));
            const response = await api.get(`/api/portaria/almocos/valores-diferenciados?${queryParams.toString()}`);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao listar valores diferenciados de almoço da portaria:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async cadastrarAlmocoPortaria(dados) {
        try {
            const response = await api.post('/api/portaria/almocos', dados);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao cadastrar almoço da portaria:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async excluirAlmocoPortaria(almocoId) {
        try {
            const response = await api.delete(`/api/portaria/almocos/${almocoId}`);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao excluir almoço da portaria:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async atualizarAlmocoPortaria(almocoId, dados) {
        try {
            const response = await api.put(`/api/portaria/almocos/${almocoId}`, dados);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao atualizar almoço da portaria:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async consultarSyncAlmocoPortaria(almocoId) {
        try {
            const response = await api.get(`/api/portaria/almocos/${almocoId}/sync-evolutize`);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao consultar status de sync do almoço da portaria:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async reprocessarSyncAlmocoPortaria(almocoId, acao) {
        try {
            const payload = acao ? { acao } : {};
            const response = await api.post(`/api/portaria/almocos/${almocoId}/reprocessar-evolutize`, payload);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao reprocessar sync do almoço da portaria:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async exportarRelatorioFechamentoAlmocos() {
        try {
            const response = await api.get('/api/portaria/almocos/relatorio', {
                responseType: 'blob',
            });
            return response.data;
        }
        catch (error) {
            console.error('Erro ao exportar relatório de fechamento de almoços:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async exportarRelatorioRH(filtros = {}) {
        try {
            const params = new URLSearchParams();
            if (filtros.tipo)
                params.append('tipo', filtros.tipo);
            if (filtros.status)
                params.append('status', filtros.status);
            if (filtros.data_inicio)
                params.append('data_inicio', filtros.data_inicio);
            if (filtros.data_fim)
                params.append('data_fim', filtros.data_fim);
            if (filtros.setor)
                params.append('setor', filtros.setor);
            if (filtros.colaborador)
                params.append('colaborador', filtros.colaborador);
            if (filtros.empresa)
                params.append('empresa', filtros.empresa);
            const queryString = params.toString();
            const url = queryString ? `/api/rh/relatorio?${queryString}` : '/api/rh/relatorio';
            const response = await api.get(url, {
                responseType: 'blob',
            });
            return response.data;
        }
        catch (error) {
            console.error('Erro ao exportar relatório RH:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
};
